import React, { useCallback, useEffect, useState } from 'react';
import { Spin } from 'antd';
import { CourseResourceApi } from './CourseResourceApi';
import type { CourseBrief } from './CourseResourceType';
import './CourseResourcePage.css';

type CourseResourcePageProps = {
  spaceId: string;
  spaceProductId: string;
  onOpenCourse?: (courseId: string) => void;
};

/** 课程资源列表页：已订阅用户浏览课程目录 */
export const CourseResourcePage: React.FC<CourseResourcePageProps> = ({
  spaceId,
  spaceProductId,
  onOpenCourse,
}) => {
  const [loading, setLoading] = useState(true);
  const [courses, setCourses] = useState<CourseBrief[]>([]);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await CourseResourceApi.listCourses({ spaceId, spaceProductId });
      setCourses(res.courses ?? []);
    } catch (e) {
      setError(e instanceof Error ? e.message : '加载失败');
      setCourses([]);
    } finally {
      setLoading(false);
    }
  }, [spaceId, spaceProductId]);

  useEffect(() => {
    void load();
  }, [load]);

  if (loading) {
    return (
      <div className="course-resource-loading">
        <Spin />
      </div>
    );
  }

  if (error) {
    return <div className="course-resource-empty">{error}</div>;
  }

  if (courses.length === 0) {
    return <div className="course-resource-empty">暂无课程</div>;
  }

  return (
    <div className="course-resource-list-page">
      <div className="course-resource-grid">
        {courses.map((course) => (
          <button
            key={course.id}
            type="button"
            className="course-resource-card"
            onClick={() => onOpenCourse?.(course.id)}
          >
            <div className="course-resource-card-cover">
              {course.coverUrl ? (
                <img src={course.coverUrl} alt="" loading="lazy" />
              ) : (
                <div className="course-resource-cover-placeholder" />
              )}
            </div>
            <div className="course-resource-card-body">
              <div className="course-resource-card-title">{course.title}</div>
              <div className="course-resource-card-meta">
                {course.lessonCount} 课时 · {course.learnerCount} 人次学习
              </div>
              {course.intro ? <div className="course-resource-card-intro">{course.intro}</div> : null}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CourseResourcePage;
